import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./store";
import { SystemFun } from "codoon-fun";
import { isInCodoon } from "./utils/bridge";

const System = SystemFun.checkSystemByUserAgent();

/**
 * 【站内 & ios】
 * html 高度设置为 100vh，以消除 ios底部安全区域空白
 */
if (isInCodoon() && System.isIOS) {
  const elm = document.documentElement;
  if (elm) {
    elm.style.height = "100vh";

    /**
     * ios：html 高度使用100vh后
     * 软键盘收起时，html会被设滚动值。导致底部空白，并且无法滚动回原状态
     */
    document.body.addEventListener("focusout", () => {
      elm.scrollTop = 0;
    });
  }
}

// 解决 safari :active 无效问题
document.body.addEventListener("touchstart", function () {});

ReactDOM.render(
  // @ts-ignore
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
